 export const initialState = {
  screens: [],
  screenReport: [],
  loading: false,
  error: null,
  };